<template>
  <div class="pt-32 pb-20 px-6 max-w-4xl mx-auto">
    <div class="glass-card p-8 md:p-12 rounded-3xl border border-white/10 relative overflow-hidden">
      <!-- Glow effect -->
      <div class="absolute -bottom-24 -left-24 w-48 h-48 bg-red-600/5 blur-3xl rounded-full"></div>
      
      <h1 class="text-4xl md:text-5xl font-black mb-10 bg-gradient-to-r from-fire-gold via-white to-fire-gold bg-clip-text text-transparent italic tracking-tight">
        MENTIONS LÉGALES
      </h1>

      <div class="space-y-12 text-gray-300 leading-relaxed">
        <!-- Section 1 -->
        <section>
          <div class="flex items-center gap-4 mb-4">
            <div class="h-px flex-1 bg-gradient-to-r from-fire-gold/50 to-transparent"></div>
            <h2 class="text-xl font-bold text-white uppercase tracking-widest">1. Présentation du site</h2>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white/5 p-6 rounded-2xl border border-white/5">
            <div>
              <p class="text-fire-gold text-xs font-bold uppercase mb-1">Propriétaire</p>
              <p class="text-white font-bold">BEST ARTIFICE SAS</p>
              <p class="text-sm">SIRET : 818 554 370 00036</p>
              <p class="text-sm">53 rue de l’Université, 69007 LYON</p>
            </div>
            <div>
              <p class="text-fire-gold text-xs font-bold uppercase mb-1">Responsable Publication</p>
              <p class="text-white font-bold">Mr SEBAA</p>
              <p class="text-sm italic">contact@authentiqueartifice.com</p>
            </div>
            <div>
              <p class="text-fire-gold text-xs font-bold uppercase mb-1">Hébergeur</p>
              <p class="text-white font-bold">o2switch</p>
              <p class="text-sm">Chemin des Pardiaux, 63000 Clermont-Ferrand</p>
            </div>
          </div>
        </section>

        <!-- Section 2 -->
        <section>
          <h2 class="text-xl font-bold text-white mb-4">2. Conditions générales d’utilisation</h2>
          <p>
            L’utilisation du site <strong>authentiqueartifice.com</strong> implique l’acceptation pleine et entière des conditions générales d’utilisation. 
            Ces conditions sont susceptibles d’être modifiées ou complétées à tout moment. Le site est normalement accessible à tout moment, 
            sauf interruption pour maintenance technique décidée par BEST ARTIFICE SAS.
          </p>
        </section>

        <!-- Section 3 -->
        <section>
          <h2 class="text-xl font-bold text-white mb-4">3. Description des services fournis</h2>
          <p>
            Le site <strong>authentiqueartifice.com</strong> a pour objet de fournir une information concernant l’ensemble des activités de la société. 
            BEST ARTIFICE s’efforce de fournir des informations aussi précises que possible, mais ne pourra être tenue responsable des omissions 
            ou inexactitudes dues à des tiers.
          </p>
        </section>

        <!-- Section 4 -->
        <section>
          <h2 class="text-xl font-bold text-white mb-4">4. Propriété intellectuelle</h2>
          <p>
            BEST ARTIFICE SAS est propriétaire des droits de propriété intellectuelle sur tous les éléments accessibles sur le site : 
            textes, images, graphismes, logo, icônes, sons, logiciels. Toute reproduction, représentation ou modification est interdite, 
            sauf autorisation écrite préalable.
          </p>
        </section>

        <!-- Section 5 -->
        <section>
          <h2 class="text-xl font-bold text-white mb-4">5. Gestion des données personnelles</h2>
          <p>
            En France, les données personnelles sont protégées par la loi n° 78-87 du 6 janvier 1978. La Société ne collecte des informations 
            personnelles que pour le besoin de certains services proposés (contact, commande). Tout utilisateur dispose d’un droit d’accès, 
            de rectification et d’opposition aux données le concernant.
          </p>
        </section>

        <!-- Section 6 -->
        <section>
          <h2 class="text-xl font-bold text-white mb-4">6. Liens hypertextes et cookies</h2>
          <p>
            La navigation sur le site est susceptible de provoquer l’installation de cookie(s). Un cookie enregistre des informations relatives 
            à la navigation afin de faciliter les visites ultérieures et permettre des mesures de fréquentation. L'utilisateur peut configurer 
            son navigateur pour refuser ces cookies.
          </p>
        </section>

        <!-- Section 7 -->
        <section>
          <h2 class="text-xl font-bold text-white mb-4">7. Droit applicable</h2>
          <p>
            Tout litige en relation avec l’utilisation du site <strong>authentiqueartifice.com</strong> est soumis au droit français. 
            Il est fait attribution exclusive de juridiction aux tribunaux compétents de Lyon.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.glass-card {
  background: rgba(10, 10, 15, 0.7);
  backdrop-filter: blur(20px);
}
</style>
